/**
 * Subratllat de les opcions (`<hover-line>`): que es quedi on el deixes.
 *
 * COMPORTAMENT DEL TEMA. El `<hover-line>` de `theme.js` escolta el
 * `mouseenter` i el `mouseleave` de CADA etiqueta. El `mouseleave` torna la
 * ratlla a l'opcio seleccionada, de manera que en passar el ratoli per la fila
 * la ratlla anava i tornava a cada talla, i tambe tornava enrere quan
 * s'entrava en una talla esgotada (que amb `pointer-events: none` ja no rep
 * events, pero el `mouseleave` de l'anterior si que s'havia disparat).
 *
 * QUE FA AQUEST SCRIPT. Nomes canvia QUAN es torna enrere: la ratlla es queda
 * a l'ultima opcio per on s'ha passat i nomes torna a la seleccionada quan el
 * ratoli surt de la FILA sencera.
 *
 * COM. S'intercepta el `mouseleave` a la fase de CAPTURA i s'atura la seva
 * propagacio, de manera que el gestor del tema no s'executa. El tema no es
 * toca: el seu `mouseenter` segueix funcionant igual i es qui mou la ratlla.
 *
 * ⚠️ El `mouseleave` NO puja (no fa bubbling), pero SI que baixa en la fase de
 * captura, i per aixo aquesta es l'unica manera d'aturar-lo sense tocar
 * `theme.js` ni tornar a registrar els gestors del tema.
 *
 * Per tornar enrere en sortir de la fila es dispara un `mouseleave` propi
 * sobre l'ultima etiqueta visitada, que es exactament el que el tema espera.
 */
(function () {
  'use strict';

  var LABEL = '.opt-label--btn';
  var ROW = '.option-selector__btns';

  function init() {
    document.querySelectorAll(ROW).forEach(function (row) {
      if (row.dataset.hbHoverLine) return;
      row.dataset.hbHoverLine = '1';

      // Ultima etiqueta per on ha passat el ratoli. Cal recordar-la: quan el
      // ratoli surt de la fila ja no hi ha cap `:hover` a qui preguntar-ho
      // (verificat: buscant-lo alla, el retorn no s'arribava a disparar).
      var last = null;

      row.addEventListener(
        'mouseover',
        function (evt) {
          var label = evt.target.closest && evt.target.closest(LABEL);
          if (label) last = label;
        },
        true
      );

      // Les opcions ESGOTADES no mouen el subratllat: la ratlla es queda a
      // l'ultima disponible per on s'ha passat.
      //
      // Cal fer-ho aqui i no amb `pointer-events: none` al CSS, perque amb
      // tres opcions un valor pot estar esgotat nomes per la combinacio
      // actual i el client hi ha de poder clicar igualment.
      row.addEventListener(
        'mouseenter',
        function (evt) {
          var label = evt.target.closest && evt.target.closest(LABEL);
          if (
            label &&
            label.previousElementSibling &&
            label.previousElementSibling.classList.contains('is-unavailable')
          ) {
            evt.stopPropagation();
          }
        },
        true
      );

      // Marca del `mouseleave` que disparem nosaltres en sortir de la fila.
      // ⚠️ Sense aixo, el bloqueig de sota tambe l'aturava i el retorn no
      // s'arribava a produir (verificat: la ratlla es quedava a la L).
      var ours = false;

      // Atura el `mouseleave` de les etiquetes abans que hi arribi el tema.
      row.addEventListener(
        'mouseleave',
        function (evt) {
          if (ours) return;
          if (evt.target !== row && evt.target.closest && evt.target.closest(LABEL)) {
            evt.stopPropagation();
          }
        },
        true
      );

      // En sortir de la FILA, el tema torna la ratlla a la seleccionada. Se li
      // dona el `mouseleave` que abans li hem amagat, sobre l'ultima etiqueta
      // visitada — que es el que el seu gestor espera.
      row.addEventListener('mouseleave', function () {
        if (!last) return;
        ours = true;
        last.dispatchEvent(new MouseEvent('mouseleave'));
        ours = false;
        last = null;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El tema refa el `<variant-picker>` sencer en canviar de variant: les files
  // noves necessiten els seus gestors. El marcador `data-hbHoverLine` evita
  // registrar-los dues vegades a les que ja en tenen.
  var picker = document.querySelector('.product-detail__form__options');
  if (picker) {
    new MutationObserver(init).observe(picker, { childList: true, subtree: true });
  }
})();
